module.exports = __webpack_public_path__ + "img/5.95dc201d.png";